/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
//import "../../App.css";
import { Job, User, OutputType, ProcessType } from '../../JmReact';

import { Button, Checkbox, Form, Icon, InputNumber, message, Tooltip } from "antd";

import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericTable from "../../components/GenericTable";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import GenericSelector from "../../components/GenericSelector";
import TableLineIcons from "../../components/TableLineIcons";

class PricesByPayments extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            openModal: false,

            modalCopy: null,
            modalCopyPosList: "",
        };

        this.id = "PRICES_BY_PAYMENTS";
        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        this.api = {
            get: "get_prices_by_payments",
            edit: "edit_prices_by_payments",
            create: "create_prices_by_payments",
            delete: "delete_prices_by_payments",
        }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    handleCreateNew = () => {
        this.props.dataActions.genericDataStartInlineCreate(this.id);
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    handleCancelEditing = () => {
        if (this.props.data[this.id].editing == 0) {
            this.props.dataActions.genericDataCancelInlineCreate(this.id);
        } else {
            this.props.dataActions.genericDataCancelEditing(this.id);
        }
    }

    handleOk = () => {
        const { editing, editedRecord, data } = this.props.data[this.id]
        if (editing == 0) {
            let issetRow = data.find(f => f.split("\f")[0] == `${editedRecord._posId}-${editedRecord._payId}`)
            if (issetRow) {
                message.error(this.getText(22104))
            } else {
                this.props.dataActions.genericDataSaveEditWithParams(
                    this.id, this.props.user.companyCode, this.props.user.token,
                    this.api.create, this.api.get, { _item: this.props.itemCode });
            }
        } else {
            this.props.dataActions.genericDataSaveEdit(
                this.id, this.props.user.companyCode, this.props.user.token,
                this.api.edit, this.api.get);
        }

    }

    handleCopy = () => {
        const { modalCopy, modalCopyPosList } = this.state
        let dataSend = "_posId\f_item\f_payId\f_price\f_isActive\r"
            + modalCopyPosList.split(",").map(x => {
                return x + "\f"
                    + this.props.itemCode + "\f"
                    + modalCopy._payId + "\f"
                    + modalCopy._price + "\f1"
            }).join("\r")
        this.sendAPI(this.api.create, dataSend, () => {
            this.setState({ modalCopy: null }, this.refreshData)
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        const gt = this.getText
        const render = t => t
        const payList = [
            { code: "1", name: gt(22094) },
            { code: "2", name: gt(22095) },
            { code: "3", name: gt(22096) },
            { code: "4", name: gt(22097) },
            { code: "5", name: gt(22098) },
            { code: "6", name: gt(22099) },
        ]
        const { editing, editedRecord } = this.props.data[this.id]


        return (<>
            <Tooltip title={gt(22087)}>
                <span style={{ fontSize: 20, cursor: "pointer" }} onClick={() => {
                    this.setState({ openModal: true })
                }}>🍲</span>
            </Tooltip>
            <GenericModal
                visible={this.state.openModal}
                onCancel={() => { this.setState({ openModal: false }) }}
                title={gt(22087)}
                width={900}
                actionButtons={[{
                    buttonType: 'add',
                    buttonFunction: this.handleCreateNew
                }, {
                    buttonType: 'refresh',
                    buttonFunction: this.refreshData
                }]}
            >
                {this.state.openModal ?
                    <GenericTable
                        {...this.props}
                        tableOnly
                        id={this.id}
                        getApi={this.api.get}
                        filters={{ _item: this.props.itemCode }}
                        columns={[
                            { title: gt(22088), key: "_posId", dataIndex: "_posId", width: "8%", render },
                            { title: gt(22100), key: "_posName", dataIndex: "_posName", width: "25%", render },
                            { title: gt(22089), key: "_payId", dataIndex: "_payId", width: "8%", render },
                            { title: gt(22090), key: "_payName", dataIndex: "_payId", width: "25%", render: t => payList.find(f => f.code == t)?.name },
                            { title: gt(22091), key: "_price", dataIndex: "_price", width: "15%", render },
                            { title: gt(22092), key: "_isActive", dataIndex: "_isActive", width: "9%", render: t => (<Icon type={t == 1 ? "check" : "close"} style={{ fontSize: 25, color: t == 1 ? "green" : "red" }} />) },
                            {
                                title: gt(22093), width: "10%", render: (t, r) => {
                                    return (<TableLineIcons
                                        onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, r.key, r.index) }}
                                        onDelete={() => {
                                            this.props.dataActions.genericDataDeleteRow(
                                                this.id, r.key + "-" + this.props.itemCode,
                                                this.props.user.companyCode, this.props.user.token,
                                                this.api.delete, this.api.get)
                                        }}
                                        deleteQuetion={{ title: gt(22105), okText: gt(22106), cancelText: gt(22107) }}
                                        genericIcons={[
                                            { type: "copy", tooltip: gt(22108), onClick: () => { this.setState({ modalCopy: r }) }, disabled: r._isActive != 1 }
                                        ]}
                                    />)
                                }
                            },
                        ]}
                    />
                    : ""}
                <GenericModal
                    visible={editing != -1}
                    onCancel={this.handleCancelEditing}
                    title={gt(22101)}
                    width={600}
                    footer={[
                        <Button onClick={this.handleCancelEditing}>{gt(22103)}</Button>,
                        <Button type="primary" onClick={this.handleOk}>{gt(22102)}</Button>,
                    ]}
                >
                    <Form.Item label={gt(22088)}>
                        {editing == 0 ?
                            <GenericSelectorPosStorages
                                {...this.props}
                                value={editedRecord._posId}
                                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { _posId: e }) }}
                            />
                            : `${editedRecord._posId} - ${editedRecord._posName}`}
                    </Form.Item>
                    <Form.Item label={gt(22089)}>
                        {editing == 0 ?
                            <GenericSelector
                                {...this.props}
                                dataset={payList}
                                value={editedRecord._payId}
                                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { _payId: e }) }}
                            />
                            : `${editedRecord._payId} - ${payList.find(f => f.code == editedRecord._payId)?.name}`}
                    </Form.Item>
                    <Form.Item label={gt(22091)}>
                        <InputNumber
                            value={editedRecord._price}
                            onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { _price: e }) }}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Checkbox
                            checked={editedRecord._isActive == 1}
                            onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { _isActive: e.target.checked ? "1" : "0" }) }}
                        >{gt(22092)}</Checkbox>
                    </Form.Item>
                </GenericModal>
                <GenericModal
                    visible={this.state.modalCopy != null}
                    onCancel={() => { this.setState({ modalCopy: null }) }}
                    title={gt(22108)}
                    width={600}
                    footer={[
                        <Button onClick={() => { this.setState({ modalCopy: null }) }}>{gt(22103)}</Button>,
                        <Button type="primary" onClick={this.handleCopy}>{gt(22102)}</Button>,
                    ]}
                >
                    <Form.Item label={gt(22109)}>
                        <GenericSelectorPosStorages
                            {...this.props} multi
                            value={this.state.modalCopyPosList ? this.state.modalCopyPosList.split(",") : []}
                            onChange={e => { this.setState({ modalCopyPosList: e ? e.join(",") : "" }) }}
                        />
                    </Form.Item>
                </GenericModal>
            </GenericModal>
        </>)
    }

}

export default PricesByPayments;